module.exports = __webpack_public_path__ + "static/img/雅迪冠能星舰S80.c543478c.png";